import axios from "axios";
import authChoice from "../../auth";
import environment from "../../env";
import { apiWrapperGenerator } from "./lib";

function getBaseUrl() {
  return environment.backendType === "firebase"
    ? environment.service[environment.env].deephowApiServer
    : environment.service[environment.env]["china"].deephowApiServer;
}

const textToSpeechSever = axios.create({
  baseURL: getBaseUrl(),
});

textToSpeechSever.interceptors.request.use(
  async (config) => {
    config.headers["x-user-token"] = await authChoice().currentUser.getIdToken();
    return config;
  },
  (error) => Promise.resolve(error)
);

const apiWrapper = apiWrapperGenerator(textToSpeechSever);

export const getTextToSpeechByIds = (params) => apiWrapper("get", `/v1/text-2-speech`, { params });

export const getTextTiSpeechHistoryById = (id) => apiWrapper("get", `/v1/workflows/${id}/text-2-speech-histories `);

export default textToSpeechSever;
